import {useEffect, useMemo, useState} from 'react';

import {
    computeOneTrustConsentAllowed,
    isOneTrustConsentGatingEnabled,
    subscribeOneTrustConsent,
} from '@/services/oneTrust/oneTrustConsent';

const useOneTrustConsentAllowed = (groupIds: string[] = []) => {
    const stableGroupIds = useMemo(() => [...groupIds], [groupIds.join(',')]);
    const isGatingEnabled = isOneTrustConsentGatingEnabled();

    const [allowed, setAllowed] = useState(() => {
        return isGatingEnabled ? computeOneTrustConsentAllowed(stableGroupIds) : true;
    });

    useEffect(() => {
        if (!isGatingEnabled) return undefined;

        return subscribeOneTrustConsent(setAllowed, stableGroupIds);
    }, [isGatingEnabled, stableGroupIds]);

    return allowed;
};

export default useOneTrustConsentAllowed;
